import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Typography } from "@lyfegen-platform/react-common";

const ReadOnlyInput = (props: { label: string; value: string }) => {
	const { t } = useTranslation();
	const { label, value } = props;

	return (
		<Box paddingLeft={1.5}>
			<Typography type="labels">{t(label)}</Typography>
			<Typography>{value}</Typography>
		</Box>
	);
};

export default ReadOnlyInput;
